/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { reconciliation_PaymentRegisterApplicationDTO } from './reconciliation_PaymentRegisterApplicationDTO';
export type reconciliation_PaymentRegisterRowDTO = {
    amountCents?: number;
    applications?: Array<reconciliation_PaymentRegisterApplicationDTO>;
    appliedCents?: number;
    bankTransactionId?: string;
    /**
     * BankTxStatus is the underlying bank_transactions.status (pending |
     * matched | unmatched | ignored). The register UI gates the Ignore vs
     * Unignore row action on it (ignored ⇒ offer Unignore).
     */
    bankTxStatus?: string;
    childId?: string;
    childInternalId?: string;
    childName?: string;
    counterpartyName?: string;
    creditCents?: number;
    debtorAccountId?: string;
    debtorLabel?: string;
    debtorType?: string;
    id?: string;
    importBatchId?: string;
    /**
     * Kind is "payment" (money in) or "refund" (money paid back out, issue
     * #1300). On a refund row: AmountCents is NEGATIVE, Applied/Credit are 0,
     * Applications is empty, the bank and child fields are absent, Status is
     * "refund", and ID is the payment_applications id — which is what
     * POST /reconciliation/refunds/{id}/revert takes, so the row's Undo needs
     * no second lookup. Clients must switch on this rather than inferring the
     * row type from a missing bankTransactionId.
     */
    kind?: reconciliation_PaymentRegisterRowDTO.kind;
    matchSource?: string;
    receivedDate?: string;
    source?: string;
    status?: string;
};
export namespace reconciliation_PaymentRegisterRowDTO {
    /**
     * Kind is "payment" (money in) or "refund" (money paid back out, issue
     * #1300). On a refund row: AmountCents is NEGATIVE, Applied/Credit are 0,
     * Applications is empty, the bank and child fields are absent, Status is
     * "refund", and ID is the payment_applications id — which is what
     * POST /reconciliation/refunds/{id}/revert takes, so the row's Undo needs
     * no second lookup. Clients must switch on this rather than inferring the
     * row type from a missing bankTransactionId.
     */
    export enum kind {
        PAYMENT = 'payment',
        REFUND = 'refund',
    }
}

